import { qs, qsa } from './utils'
import { gsap, Power4 } from 'gsap'
import barba from '@barba/core'

import { Color } from 'three'
import smoke from './webgl/smoke/smoke'
import world from './webgl/world/world'
import inspire from './webgl/inspire/inspire'
import { addClass, qs, qsa, removeClass } from './utils'
import home from './routes/home'
import scroll from './animations/scroll/locomotiveScroll'
import stars from './webgl/stars/stars'

class Menu {
  constructor() {
    isOpen: false
    isAnimating: false
    bindedHandle: null
    bindedEsc: null
  }

  init() {
    this.menu = qs('[data-menu]')
    this.container = null
    this.toggle = qs('[data-menu-toggle]')
    this.navItems = qsa('[data-item]', this.menu)
    this.background = qs('[data-background]', this.menu)
    this.socials = qsa('[data-social]', this.menu)
    this.sides = qsa('[data-side]', this.menu)
    this.colors = {
      open: new Color(0x023744),
      closed: new Color(0x011c22)
    }

    this.initListeners()

    if (barba.data.current.namespace !== 'home') {
      home.isAlreadyEntered = true
    }
  }

  initListeners() {
    this.bindedHandle = this.handleClick.bind(this)
    this.toggle.addEventListener('click', this.bindedHandle)
  }

  removeListeners() {
    this.toggle.removeListeners('click', this.bindedHandle)
  }

  handleClick() {
    if(this.isAnimating) return

    this.isAnimating = true
    this[this.isOpen ? 'menuLeave' : 'menuEnter']()
  }

  initEscListener() {
    this.bindedEsc = this.keyHandler.bind(this)

    window.addEventListener('keydown', this.bindedEsc)
  }

  removeEscListener() {
    window.removeEventListener('keydown', this.bindedEsc)
  }

  keyHandler(e) {
    if (this.isAnimating) return

    if (e.key === 'Escape') {
      this.isAnimating = true
      this.menuLeave()
    }
  }

  activeClassToMenu() {
    const { href } = window.location

    this.navItems.forEach(voice => {
      if (voice.getAttribute('href') === href) {
        addClass(voice, 'is-active')
      } else {
        removeClass(voice, 'is-active')
      }
    })
  }

  menuEnter() {
    if (barba.data.current.namespace === 'archive-inspire') {
      inspire.fastLeave()
      // stars.fastLeave()
    }

    if (barba.data.current.namespace === 'home') {
      stars.fastLeave()
    }

    this.activeClassToMenu()

    this.initEscListener()
    this.toggle.classList.add('open')
    this.isOpen = !this.isOpen
    this.container = qs('[data-barba="container"]')

    if (barba.data.current.namespace === 'home') {
      const dummy = { value: 1 }
      const tl = gsap.timeline()

      tl
        .to(dummy, {
          duration: 0.8,
          value: 0,
          ease: Power4.easeOut,
          onUpdate: () => {
            world.setWorldOpacity(dummy.value)
          }
        })
        .add(() => {
          world.visible = false
          // smoke.visible = true
        })
        // .fromTo(smoke.material.uniforms.uFade, {
        //   value: 0
        // },{
        //   duration: 0.8,
        //   value: 1,
        //   ease: Power4.easeOut
        // })
    }

    const tl = gsap.timeline({ onComplete: () => {
      this.isAnimating = false
    }})

    tl
      .set(this.menu, {
        display: 'flex'
      })
      .add('start')
      .to(this.container, {
        duration: 1.2,
        autoAlpha: 0,
        ease: Power4.easeOut
      }, 'start')
      .to(smoke.material.uniforms.uColor.value, {
        duration: 1.2,
        r: this.colors.open.r,
        g: this.colors.open.g,
        b: this.colors.open.b,
        ease: Power4.easeOut
      }, 'start')
      .from(this.navItems, {
        duration: 1.2,
        yPercent: 150,
        stagger: 0.04,
        transformOrigin: 'left top',
        ease: Power4.easeOut
      }, '-=0.8')
      .from(this.socials, {
        duration: 1.2,
        yPercent: 150,
        stagger: 0.04,
        transformOrigin: 'left top',
        ease: Power4.easeOut
      }, '-=1')
      .from(this.sides, {
        duration: 1.2,
        yPercent: 20,
        xPercent: (i) => i % 2 === 0 ? -100 : 100,
        transformOrigin: 'right bottom',
        ease: Power4.easeOut
      }, '-=1.2')
  }

  menuLeave() {
    this.removeEscListener()
    this.toggle.classList.remove('open')
    this.isOpen = !this.isOpen
    this.container = qs('[data-barba="container"]')

    const hasNextRoute = barba.data.next?.namespace?.length
    const currentRoute = barba.data.current?.namespace
    const nextRoute = barba.data.next?.namespace

    const namespace = hasNextRoute
      ? nextRoute
      : currentRoute

    if (!hasNextRoute && currentRoute === 'archive-inspire') {
      inspire.fastEnter()
    }

    if (!hasNextRoute && currentRoute === 'home') {
      const dummy = { value: 0 }
      const tl = gsap.timeline()

      tl
        // .to(smoke.material.uniforms.uFade, {
        //   duration: 0.8,
        //   value: 0,
        //   ease: Power4.easeOut
        // })
        .add(() => {
          world.visible = true
          // smoke.visible = false
        })
        .to(dummy, {
          delay: 0.8,
          duration: 0.8,
          value: 1,
          ease: Power4.easeOut,
          onUpdate: () => {
            world.setWorldOpacity(dummy.value)
          }
        })

      stars.fastEnter()
    }

    // if (!hasNextRoute && ) {
    // } else {
    //   stars.fastLeave()
    // }

    const tl = gsap.timeline({ onComplete: () => {
      this.isAnimating = false

      if (namespace !== 'home') {
        scroll.start()
      }
    }})

    tl
      .to(this.navItems, {
        duration: 1.2,
        yPercent: 150,
        stagger: 0.04,
        transformOrigin: 'left top',
        ease: Power4.easeOut
      })
      .to(this.socials, {
        duration: 1.2,
        yPercent: 150,
        stagger: 0.02,
        transformOrigin: 'left top',
        ease: Power4.easeOut
      }, '-=1.2')
      .to(this.sides, {
        duration: 1.2,
        yPercent: 20,
        xPercent: (i) => i % 2 === 0 ? -100 : 100,
        transformOrigin: 'right bottom',
        ease: Power4.easeOut
      }, '-=1.2')
      .add('final')
      .to(this.container, {
        autoAlpha: 1
      }, 'final')
      .to(smoke.material.uniforms.uColor.value, {
        duration: 1.2,
        r: this.colors.closed.r,
        g: this.colors.closed.g,
        b: this.colors.closed.b,
        ease: Power4.easeOut
      }, 'final-=1.4')
      .set([this.menu, ...this.navItems, ...this.socials, ...this.sides, this.background], { clearProps: 'all' })
  }
}

export default new Menu()
